import React from 'react';
import { useRecordContext, TextField } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { TextQuestionParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Hemsida',
  [languages.EN]: 'Website',
  [languages.DE]: 'Webseite',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Website = ({ extraParameters }: { extraParameters?: TextQuestionParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source="website"
      datapoint={conflictFields.WEBSITE}
      identificationInfo={undefined}
    >
      <ValueField />
    </Answer>
  );
};

Website.ValueField = ValueField;

export default Website;
